"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const PayeeFilter_1 = __importDefault(require("@Components/PayeeFilter"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const TipaltiIFrame_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceBankingTab/TipaltiIFrame"));
const contexts_1 = require("@App/contexts");
const rightsholder_1 = require("@App/api/routes/rightsholder/rightsholder");
const mobx_react_1 = require("mobx-react");
const PayeeBankingInfo = () => {
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [preloaderIsOpen, setPreloaderIsOpen] = (0, react_1.useState)(false);
    const [tipaltiIframe, setTipaltiIframe] = (0, react_1.useState)({});
    const [selectedPayee, setSelectedPayee] = (0, react_1.useState)();
    const getData = () => __awaiter(void 0, void 0, void 0, function* () {
        setPreloaderIsOpen(true);
        yield rightsholderStore.loadPayees();
        const payeeToLoad = rightsholderStore.payeeOptions.length
            ? rightsholderStore.payeeOptions[0]
            : {
                id: rightsholderStore.currentRightsholderId.toString(),
                value: rightsholderStore.currentRightsholderId.toString(),
                label: rightsholderStore.memberSummary.name,
            };
        yield setNewSelectedPayee(payeeToLoad);
    });
    const setNewSelectedPayee = (newSelectedPayee) => __awaiter(void 0, void 0, void 0, function* () {
        setPreloaderIsOpen(true);
        const result = yield (0, rightsholder_1.getRightsHolderTipaltiIframe)(rightsholderStore.currentRightsholderId, Number(newSelectedPayee.id));
        setSelectedPayee(newSelectedPayee);
        setTipaltiIframe(result.data);
        setPreloaderIsOpen(false);
    });
    (0, react_1.useEffect)(() => {
        getData().then();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(PayeeFilter_1.default, { payeeOptions: rightsholderStore.payeeOptions, setPayee: setNewSelectedPayee, selectedPayee: selectedPayee }),
        preloaderIsOpen || !tipaltiIframe ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(TipaltiIFrame_1.default, { tipaltiIFrame: tipaltiIframe, setPreloaderIsOpen: setPreloaderIsOpen }))));
};
exports.default = (0, mobx_react_1.observer)(PayeeBankingInfo);
